<script setup lang="ts">
import { computed } from 'vue';

import { webAuth } from '../../auth/web-auth.js';

/**
 * `/pendente` e `/suspenso`: mensagem curta e saída. Nenhum dado de negócio
 * é pedido daqui.
 */
const props = defineProps<{ state: 'pending' | 'suspended' | 'conflict' }>();

const message = computed(
  () =>
    ({
      pending: 'Acesso aguardando liberação.',
      suspended: 'Acesso suspenso.',
      conflict: 'Não foi possível confirmar seu acesso. Procure o administrador.',
    })[props.state],
);
</script>

<template>
  <main class="auth-card">
    <h1>Sigfarm RFID</h1>
    <p role="status">
      {{ message }}
    </p>
    <button
      type="button"
      @click="webAuth().logout()"
    >
      Sair
    </button>
  </main>
</template>

<style scoped>
.auth-card { max-width: 28rem; margin: 15vh auto; padding: 1.5rem; font-family: system-ui, sans-serif; text-align: center; }
h1 { font-size: 1.25rem; }
button { margin-top: 1rem; padding: .5rem 1rem; font: inherit; cursor: pointer; }
</style>
